<template>
  <!-- Content Wrapper. Contains page content -->
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tổng quan cấu trúc doanh nghiệp">
          <div slot="content">
            <div class="company-general">
              <b-card v-for="department in departments" :key="department.id" no-body class="mb-1">
                <b-card-header @click="showRoles(department)">
                  <router-link :to="{ name: 'DepartmentList'}">{{ department.department_name }}</router-link>
                  <i class="fa fa-angle-up" v-if="!department.visible"></i>
                  <i class="fa fa-angle-down" v-if="department.visible"></i>
                </b-card-header>
                <b-collapse v-model="department.visible" visible>
                  <b-card-body>
                    <b-list-group>
                      <b-list-group-item v-for="role in department.roles" :key="role.id">
                        <router-link :to="{ name: 'RoleList'}">{{ role.role_name }}</router-link>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </va-box>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import DeparmentAPI from '../../api/department'
import Utils from '../../common/utils'
import {mapGetters} from 'vuex'
import RoleAPI from '../../api/role'
import VABox from 'va/widgets/VABox.vue'

export default {
  name: 'General',
  components: {
    'va-box': VABox,
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  data () {
    return {
      departments: [],
      loading: true,
      company: null
    }
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.initDepartment()
  },
  methods: {
    initDepartment () {
      DeparmentAPI.filter({company_id: this.company.id}, 0, 1000).then(res => {
        this.loading = false
        this.departments = res.data.data.records.map(item => {
          item['visible'] = false
          item['roles'] = []
          return item
        })
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    showRoles (department) {
      if (department.roles.length > 0) {
        department.visible = !department.visible
        return
      }
      this.loading = true
      RoleAPI.filter({company_id: this.company.id, department_id: department.id, role_id: null}, 0, 1000).then(res => {
        this.loading = false
        department['roles'] = res.data.data.records
        department.visible = !department.visible
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    }
  },
}
</script>

<style scoped lang="scss">
.company-general {
  button {
    border: none;
    background-color: transparent;
    color: black;
  }

  .card-header {
    border-bottom: none;
    display: flex;
    justify-content: space-between;
  }

  .list-group-item {
    border: none;
  }

  a {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user_management/General.vue